import { FocusableOption, Highlightable } from '@angular/cdk/a11y';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    tabindex: '-1'
  },
  styles: [`
        :host:focus {
              background: #EBEEF5;
              outline: none;
           }
    `]
})
export class ListItemComponent implements Highlightable, FocusableOption {
  @Input() item;
  @Input() disabled = false;
  private _isActive = false;

  constructor(
    private host: ElementRef
  ) { }

  @HostBinding('class.active') get isActive() {
    return this._isActive;
  }
  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled;
  }

  setActiveStyles() {
    this._isActive = true;
    this.host.nativeElement.scrollIntoViewIfNeeded();
    this.focus();
  }

  setInactiveStyles() {
    this._isActive = false;
  }

  // TODO: Implement getLabel it used for withTypeAhead.
  getLabel() {
    return this.item;
  }

  focus() {
    try {
      this.host.nativeElement.focus();
    } catch (err) {
      console.warn(err, 'Problem setting focus');
    }
  }

}
